
<div class="register-container">
    <img alt="" class="blue-check-icon" src="./assets/images/blue_check_icon.png">
    <div>{{getString('registrationSuccessful')}}!</div>
    <a class="login-link" (click)="loginClick()">{{getString('login')}}</a>
</div>